import angular from 'angular';
import APIV5 from '~/models/api';

export default class ModalKfileTreeController {
	/* @ngInject */
	/**
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {boolean} local
	 * @param {boolean} multiple
	 * @param {(import('@knitiv/api-client-javascript').KFileTreeItem & {selected?: boolean})[]} items
	 */
	constructor(
		$scope,
		$timeout,
		$uibModalInstance,
		local,
		multiple,
		items,
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;

		/** @type {import('@knitiv/api-client-javascript').KFileTreeDir[]} */
		this.aPath = [{
			name:       '',
			relpath:    '',
			selectable: true,
			tree_kid:   null,
			type:       'dir',
		}];

		/** @type {boolean} */
		this.flagSelectAll = false;

		this.items = items;

		/** @type {?import('@knitiv/api-client-javascript').KFileTreeItem & {selected?: boolean}} */
		this.lastSelected = null;

		/** @type {boolean} */
		this.loading = false;

		this.local = local;

		this.multiple = multiple || false;

		/** @type {string} */
		this.name = '';

		/** @type {string} */
		this.path = '';

		/**
		 * @type {(import('@knitiv/api-client-javascript').KFileTreeItem & {selected?: boolean})[]
		 *   | import('@knitiv/api-client-javascript').KFileTreeItem & {selected?: boolean}
		 *   | null}
		 */
		this.selected = [];

		this.tree_kid = null;
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KFileTreeDir} item
	 */
	async cd(item) {
		this.loading = true;
		if (item.tree_kid) {
			const result = await APIV5.instance.kFileTreeGet(
				{
					relpath:  item.relpath,
					tree_kid: item.tree_kid,
				},
				{
					id: 'modal-kfile-tree.cd',
				},
			);
			if (result) {
				this.items = result.items;
				this.loading = false;
				this.name = item.name;
				this.path = item.relpath;
				this.selected = this.multiple ? [] : null;
				this.tree_kid = item.tree_kid;
				this.$timeout(() => this.$scope.$apply());
			}
		}
	}

	/**
	 * @param {any[]} files
	 */
	import(files) {
		this.$uibModalInstance.close(files);
	}

	async parent() {
		this.aPath.pop();
		await this.cd(this.aPath[this.aPath.length - 1]);
	}

	scrollLeft() {
		const $container = angular.element('.modal-kfile-tree-navbar-overflow-container');
		$container.scrollLeft(($container.scrollLeft() || 0) - 20);
	}

	scrollRight() {
		const $container = angular.element('.modal-kfile-tree-navbar-overflow-container');
		$container.scrollLeft(($container.scrollLeft() || 0) + 20);
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KFileTreeItem & {selected?: boolean}} item
	 * @param {boolean} button
	 */
	async select(item, button) {
		if (item.selectable) {
			this.flagSelectAll = false;
			if (item.type === 'file') {
				item.selected = !item.selected;
				if (this.multiple) {
					if (!Array.isArray(this.selected)) {
						this.selected = [];
					}
					if (item.selected) {
						this.selected.push(item);
					}
					else {
						this.selected.splice(this.selected.indexOf(item), 1);
					}
				}
				else if (item.selected) {
					if (this.lastSelected) {
						this.lastSelected.selected = false;
					}
					this.selected = item;
					this.lastSelected = item;
				}
				else {
					this.selected = null;
				}
			}
			else if (item.type === 'dir') {
				if (!button) {
					let indexToRemove = -1;
					for (const [k, p] of this.aPath.entries()) {
						if (p.relpath === this.path && p.tree_kid === this.tree_kid) {
							indexToRemove = k;
						}
					}
					if (indexToRemove >= 0) {
						this.aPath.splice(indexToRemove + 1);
					}
				}

				if (!this.aPath.includes(item)) {
					this.aPath.push(item);
				}
				await this.cd(item);
			}
		}
	}

	selectAll() {
		this.flagSelectAll = !this.flagSelectAll;
		for (const item of this.items) {
			if (item.selectable && item.type === 'file') {
				if (!Array.isArray(this.selected)) {
					this.selected = [];
				}
				item.selected = this.flagSelectAll;
				if (item.selected) {
					this.selected.push(item);
				}
				else {
					this.selected.splice(this.selected.indexOf(item), 1);
				}
			}
		}
	}

	submit() {
		this.$uibModalInstance.close(this.selected);
	}
}
